import { Field, FieldType, FieldWithPickupOptions, FormResponse } from "types";
import { getFormResponseField } from "../helpers/formResponseHelper";

export const isMarketingConsent = (field: Field | FieldWithPickupOptions) => {
    return field.type === FieldType.MARKETING_CONSENT;
};

export const isPickupLocation = (field: Field | FieldWithPickupOptions) => {
    return field.type === FieldType.PICKUP;
};

export const isHowYouHearAboutUs = (field: Field | FieldWithPickupOptions) => {
    return (
        (field.type === FieldType.TEXT || field.type === FieldType.SELECT) &&
        field.label?.toLowerCase().includes("how did you hear about us")
    );
};

export const isAddonField = (fieldType: FieldType) => {
    return fieldType === FieldType.ADDON;
};

export const getFieldPhotoPath = (
    fieldLabel: string,
    guestFormResponse?: FormResponse,
    itemFormResponse?: FormResponse,
): { photoPath: string | undefined; isItemLevelPhoto: boolean } => {
    const guestPhotoPath = getFormResponseField(guestFormResponse, fieldLabel)?.value;
    if (guestPhotoPath) {
        return { photoPath: guestPhotoPath, isItemLevelPhoto: false };
    }

    if (itemFormResponse) {
        const itemField = getFormResponseField(itemFormResponse, fieldLabel);
        if (itemField) {
            return { photoPath: itemField.value || undefined, isItemLevelPhoto: true };
        }
    }

    return { photoPath: undefined, isItemLevelPhoto: false };
};

export const shouldSkipQuestionnaireModal = (
    field: Field | FieldWithPickupOptions,
    formResponse?: FormResponse,
    isItemLevel = false,
): boolean => {
    const isOrganizerOnlySpecialField =
        field.organizerOnly && (isMarketingConsent(field) || isPickupLocation(field) || isHowYouHearAboutUs(field));

    const isPickupLocationOrganizerField = isPickupLocation(field) && field.organizerOnly;

    const hasExistingResponse =
        formResponse?.fields?.some((responseField) => {
            if (responseField.label !== field.label) {
                return false;
            }

            if (isItemLevel) {
                return true;
            }

            const value = responseField.value;

            if (typeof value === "string") {
                return value.trim().length > 0;
            }

            return !!value;
        }) ?? false;

    if (!formResponse && isItemLevel) {
        return !isOrganizerOnlySpecialField;
    }

    if (isOrganizerOnlySpecialField) {
        // it's needed cos on submit questionnaire modal can remove pickup location field if it's empty
        // cos it leads to API error
        if (isItemLevel && isPickupLocationOrganizerField) {
            return false;
        }

        return !hasExistingResponse;
    }

    if (isItemLevel) {
        return formResponse ? !hasExistingResponse : false;
    }

    return false;
};
